import { MutationTree } from 'vuex';
import { State } from './state';
import { ProspectMutations } from './mutation-types';
import {
  ProspectApiResponse,
  ProspectDetailsResponse,
  ProspectPortfolioDetailsResponse,
} from './types';

export type Mutations<S = State> = {
  [ProspectMutations.SET_SEARCH_LIST](
    state: S,
    payload: ProspectApiResponse
  ): void;
  [ProspectMutations.SET_PORTFOLIOS](
    state: S,
    payload: {
      prospects: Array<ProspectPortfolioDetailsResponse>;
      clientId: string;
    }
  ): void;
  [ProspectMutations.SET_PROSPECT_PORTFOLIOS_LOADING](
    state: S,
    isLoading: boolean
  ): void;
  [ProspectMutations.CLEAR_STATE](state: S, payload: null): void;
  [ProspectMutations.SET_PROSPECT_DETAILS](
    state: S,
    payload: ProspectDetailsResponse
  ): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [ProspectMutations.SET_SEARCH_LIST](state, payload) {
    state.searchResults = payload.results;
    state.searchResultsCount = payload.count;
  },
  [ProspectMutations.SET_PORTFOLIOS](state, payload) {
    state.portfolios = payload.prospects;
    state.selectedClientId = payload.clientId;
  },
  [ProspectMutations.SET_PROSPECT_PORTFOLIOS_LOADING](
    state: State,
    isLoading: boolean
  ) {
    state.prospectPortfoliosIsLoading = isLoading;
  },
  [ProspectMutations.CLEAR_STATE](state) {
    state.selectedClientId = null;
    state.portfolios = [];
    state.searchResults = [];
    state.prospectDetails = {} as ProspectDetailsResponse;
  },
  [ProspectMutations.SET_PROSPECT_DETAILS](state, payload) {
    state.prospectDetails = payload;
  },
};
